import { Component, Input, OnInit } from '@angular/core';

export interface DetailField {
  name?: string | null;
  value?: string | Date | null;
}

export interface Action {
  code: string;
  name: string;
}

export interface ListItemDetailsData<T> {
  details: DetailField[];
  actions?: Action[];
  component?: T;
}

export interface ListItemDetailsActionInvoke<T> {
  action: string;
  component?: T;
}

@Component({
  selector: 'list-item-details',
  templateUrl: './list-item-details.component.html',
  styleUrls: ['./list-item-details.component.scss']
})
export class ListItemDetailsComponent<T> implements OnInit {


  @Input() data?: ListItemDetailsData<T>;

  constructor() {
  }

  ngOnInit(): void {
  }

  isDate(value: string | Date) {
    return value instanceof Date;
  }

}
